import React,{useEffect,useMemo,useRef,useReducer} from "react";
import css from "./SearchBtn.module.css";
import {capitalize,fadeIn,fadeOut} from "vritra";
import {libexports} from "Resources";
import {GetStartedScreen} from "Screens";
import {magnifier0} from "Assets";


export default function SearchBtn(props){
    const {onToggle,searchBarShown}=props;
    const [state,setState]=useReducer((s,a)=>({...s,...a}),{
        selectedIndex:-1,
        searching:searchBarShown,
        options:null,
    }),{searching,options}=state;
    const searchbtnRef=useRef();
    const libentries=useMemo(()=>searching&&getEntries(),[searching]);
    
    useEffect(()=>{
        const fieldEl=searchbtnRef.current.querySelector(`.${css.field}`);
        if(searching){
            fadeIn(fieldEl,"flex",statics.fadeDuration);
            fieldEl.querySelector(":scope>input").focus();
        }
        else fadeOut(fieldEl,100);
        onToggle&&onToggle(searching);
    },[searching]);
    useEffect(()=>{
        const onKeyDown=(event)=>{
            let {selectedIndex}=state;
            switch(event.key){
                case "ArrowDown":
                    if(selectedIndex<(state.options?.length-1)) selectedIndex++;break;
                case "ArrowUp": 
                    if(selectedIndex>0) selectedIndex--;break;
                case "Enter":
                    const lis=searchbtnRef.current.querySelectorAll("li");
                    lis[selectedIndex]?.click();
                default:break;
            }
            if(selectedIndex!==state.selectedIndex){
                const lis=searchbtnRef.current.querySelectorAll("li");
                lis[selectedIndex]?.scrollIntoView();
                setState({selectedIndex});
            }
        };
        window.addEventListener("keydown",onKeyDown);
        return ()=>{
            window.removeEventListener("keydown",onKeyDown);
        }
    },[state.selectedIndex,options]);
    return (
        <div ref={searchbtnRef} className={css.searchbtn}>
            <img 
                className={`button ${css.icon}`} 
                alt="" role="button" src={magnifier0(textColor)}
                onClick={()=>{setState({searching:!searching})}}
            />
            <div 
                className={css.field}
                style={styles.field(options)}
            >
                <input 
                    placeholder={language.get("findSomething")+" ..."}
                    onInput={(event)=>{
                        const value=event.target.value.trim().toLowerCase();
                        setState({
                            selectedIndex:-1,
                            options:((!searchBarShown)||value)&&findEntries(libentries,value),
                        });
                    }}
                />
                {options&&
                    <ul className={css.options}>
                        {options.map(({id,name,libId,libName},i)=>(
                            <li 
                                key={id+libId}
                                aria-selected={""+(state.selectedIndex===i)}
                                onClick={()=>{
                                    location.hash="#/"+libId+"#"+id;
                                    searchbtnRef.current.querySelector("input").value="";
                                    setState({options:null});
                                }}
                            >
                                <p>{name||id}</p>
                                <span>{libName||libId}</span>
                            </li>
                        ))}
                    </ul>
                }
            </div>
        </div>
    )
}

const statics=SearchBtn.statics={
    fadeDuration:350,
},styles={
    field:(options)=>options?{
        borderBottomLeftRadius:0,
        borderBottomRightRadius:0,
    }:undefined,
}

const findEntries=(entries,query)=>entries.filter(({id,name,libName})=>(
    id.toLowerCase().includes(query)||
    name?.toLowerCase().includes(query)||
    libName?.toLowerCase().includes(query)
));

const getEntries=()=>{
    const entries=[];
    for(const key in libexports){
        const library=libexports[key];
        function addEntries(items){
            items?.forEach(item=>{
                entries.push({
                    id:item.id,
                    name:item.name,
                    libId:key,
                    libName:library.name,
                });
                addEntries(item.entries);
            });
        }
        addEntries(library.docs);
    }
    GetStartedScreen.statics.entries.forEach(function addEntry(entry){
        const subentries=entry.entries||[entry];
        subentries.forEach(item=>{
            const {id}=item;
            entries.push({
                id,name:item.name,
                libId:"getstarted",
                libName:entry.name,
            });
            item.entries&&addEntry(item);
        });
    });
    entries.sort((b,a)=>b.id.toLowerCase()>a.id.toLowerCase()?1:-1);
    entries.forEach(entry=>{
        entry.name=capitalize(entry.name);
    });
    return entries;
} 
